/* eslint semi:0 */
import { getIsDesktop } from '../../../utils/ua'
import { makeImage } from '../../../utils/dom'
import { makeSafeFn } from '../../../utils/fn'
import userStore from '../../stores/userStore'
import { queryString } from '../../../utils/window'
import { external as externalScript } from '../../../utils/script'
import { HEART_BEAT_PERIOD } from '../../stores/analytics/analyticsStore'
import AnalyticsBaseService from '../../services/analytics/analyticsBaseService'
import { SCROLL_EVENTS_SELECTORS } from '../../../config/preRenderedSelectorsConfig'
import { get as getFromPdo, singleFeaturedTeam } from '../../../application/pageDataObject'

// const fbPixel = externalScript.load({ name: 'facebookPixel' })
// fbPixel(makeSafeFn(_ => window.fbq('init', getFromPdo('config.facebook_pixel.id'))))

const DEFINED_EVENTS = [
  'PageView',
  'ViewContent',
  'Search',
  'AddToCart',
  'AddToWishlist',
  'InitiateCheckout',
  'AddPaymentInfo',
  'Purchase',
  'Lead',
  'CompleteRegistration',
]

export default class FacebookAnalyticsService extends AnalyticsBaseService {
  get className() {
    return 'FacebookAnalyticsService'
  }

  pageViewed() {
    // const oldPixels = getFromPdo('config.facebook_pixel.old_pixels') || []
    // for (const oldPixel of oldPixels) {
    //   this.trackEventOld(oldPixel)
    // }
    // this.trackEvent('PageView')
    // this.multiPageViews()
    // this.desktopPageview()
  }

  // multiPageViews() {
  //   const postsInSession = Object.keys(userStore.recentReads).length
  //   if (postsInSession > 1) {
  //     this.trackEvent('multiPostsViews', { numPosts: postsInSession })
  //   }
  // }

  // desktopPageview() {
  //   if (getIsDesktop()) {
  //     this.trackEvent('desktopPageview')
  //   }
  // }

  routeChanged(action) {
    //Empty override to prevent a read report on slideshows on each slide change
  }

  // scrollAnchorReached(action) {
  //   if (action.payload.anchor === SCROLL_EVENTS_SELECTORS.SHARE_BUTTONS_BOTTOM) {
  //     this.reportOnce(action, () => {
  //       this.trackEvent('ScrolledToArticleEnd')
  //     })
  //   }
  // }

  // heartBeat() {
  //   const millisecondsPassed = this.store.heartbeatsCount * HEART_BEAT_PERIOD
  //   if (millisecondsPassed === 30000) {
  //     this.trackEvent('HalfMinuteOnPage')
  //   }
  // }

  // socialShare(action) {
  //   this.trackEvent('SharedArticle')
  // }

  get defaultEventArgs() {
    return {}
  }

  trackEvent(type, args) {
    const data = Object.assign({}, this.defaultEventArgs, args) //NOTICE: for some reason when using makeEmptyObj in Object.assign instead of {}, then it doesn't work and the fbq SDK raise an error
    const trackType = DEFINED_EVENTS.includes(type) ? 'track' : 'trackCustom'
    this.logAnalytics(type, data)
    // fbPixel(makeSafeFn(_ => window.fbq(trackType, type, data)))
  }

  // trackEventOld(pixelUrl) {
  //   this.logAnalytics(pixelUrl)
  //   makeImage({ src: pixelUrl })
  // }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/analytics/facebookAnalyticsService.js